import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import Select from "./Select";
import Button from "./Button";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { openCart } from "../redux/actions/NavActions";
import Swiper from "react-id-swiper";
import {
  createCheckout,
  addToCart,
  fetchCheckout
} from "../redux/actions/CartActions";
import Countdown, { zeroPad } from "react-countdown-now";
import { device } from "../utils/devices";
import MobileProductSlider from "./MobileProductSlider";

const Wrapper = styled.div`
  position: relative;
  padding: ${props => (props.releaseDate ? "1rem 0 0" : "1rem 0 0;")};
  overflow: hidden;
  box-sizing: border-box;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    pointer-events: none;
    background-color: rgb(230, 230, 230);
    opacity: 0.08;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAUVBMVEWFhYWDg4N3d3dtbW17e3t1dXWBgYGHh4d5eXlzc3OLi4ubm5uVlZWPj4+NjY19fX2JiYl/f39ra2uRkZGZmZlpaWmXl5dvb29xcXGTk5NnZ2c8TV1mAAAAG3RSTlNAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEAvEOwtAAAFVklEQVR4XpWWB67c2BUFb3g557T/hRo9/WUMZHlgr4Bg8Z4qQgQJlHI4A8SzFVrapvmTF9O7dmYRFZ60YiBhJRCgh1FYhiLAmdvX0CzTOpNE77ME0Zty/nWWzchDtiqrmQDeuv3powQ5ta2eN0FY0InkqDD73lT9c9lEzwUNqgFHs9VQce3TVClFCQrSTfOiYkVJQBmpbq2L6iZavPnAPcoU0dSw0SUTqz/GtrGuXfbyyBniKykOWQWGqwwMA7QiYAxi+IlPdqo+hYHnUt5ZPfnsHJyNiDtnpJyayNBkF6cWoYGAMY92U2hXHF/C1M8uP/ZtYdiuj26UdAdQQSXQErwSOMzt/XWRWAz5GuSBIkwG1H3FabJ2OsUOUhGC6tK4EMtJO0ttC6IBD3kM0ve0tJwMdSfjZo+EEISaeTr9P3wYrGjXqyC1krcKdhMpxEnt5JetoulscpyzhXN5FRpuPHvbeQaKxFAEB6EN+cYN6xD7RYGpXpNndMmZgM5Dcs3YSNFDHUo2LGfZuukSWyUYirJAdYbF3MfqEKmjM+I2EfhA94iG3L7uKrR+GdWD73ydlIB+6hgref1QTlmgmbM3/LeX5GI1Ux1RWpgxpLuZ2+I+IjzZ8wqE4nilvQdkUdfhzI5QDWy+kw5Wgg2pGpeEVeCCA7b85BO3F9DzxB3cdqvBzWcmzbyMiqhzuYqtHRVG2y4x+KOlnyqla8AoWWpuBoYRxzXrfKuILl6SfiWCbjxoZJUaCBj1CjH7GIaDbc9kqBY3W/Rgjda1iqQcOJu2WW+76pZC9QG7M00dffe9hNnseupFL53r8F7YHSwJWUKP2q+k7RdsxyOB11n0xtOvnW4irMMFNV4H0uqwS5ExsmP9AxbDTc9JwgneAT5vTiUSm1E7BSflSt3bfa1tv8Di3R8n3Af7MNWzs49hmauE2wP+ttrq+AsWpFG2awvsuOqbipWHgtuvuaAE+A1Z/7gC9hesnr+7wqCwG8c5yAg3AL1fm8T9AZtp/bbJGwl1pNrE7RuOX7PeMRUERVaPpEs+yqeoSmuOlokqw49pgomjLeh7icHNlG19yjs6XXOMedYm5xH2YxpV2tc0Ro2jJfxC50ApuxGob7lMsxfTbeUv07TyYxpeLucEH1gNd4IKH2LAg5TdVhlCafZvpskfncCfx8pOhJzd76bJWeYFnFciwcYfubRc12Ip/ppIhA1/mSZ/RxjFDrJC5xifFjJpY2Xl5zXdguFqYyTR1zSp1Y9p+tktDYYSNflcxI0iyO4TPBdlRcpeqjK/piF5bklq77VSEaA+z8qmJTFzIWiitbnzR794USKBUaT0NTEsVjZqLaFVqJoPN9ODG70IPbfBHKK+/q/AWR0tJzYHRULOa4MP+W/HfGadZUbfw177G7j/OGbIs8TahLyynl4X4RinF793Oz+BU0saXtUHrVBFT/DnA3ctNPoGbs4hRIjTok8i+algT1lTHi4SxFvONKNrgQFAq2/gFnWMXgwffgYMJpiKYkmW3tTg3ZQ9Jq+f8XN+A5eeUKHWvJWJ2sgJ1Sop+wwhqFVijqWaJhwtD8MNlSBeWNNWTa5Z5kPZw5+LbVT99wqTdx29lMUH4OIG/D86ruKEauBjvH5xy6um/Sfj7ei6UUVk4AIl3MyD4MSSTOFgSwsH/QJWaQ5as7ZcmgBZkzjjU1UrQ74ci1gWBCSGHtuV1H2mhSnO3Wp/3fEV5a+4wz//6qy8JxjZsmxxy5+4w9CDNJY09T072iKG0EnOS0arEYgXqYnXcYHwjTtUNAcMelOd4xpkoqiTYICWFq0JSiPfPDQdnt+4/wuqcXY47QILbgAAAABJRU5ErkJggg==);
  }

  .slick-track {
    display: flex;
    align-items: center;

    img {
      width: 100%;
    }
  }

  @media ${device.laptop} {
    height: auto;
    padding: 0;
    /* display: grid; */
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    grid-column: 1 / span 3;
  }
`;

const Info = styled.div`
  padding: 5vw;
  z-index: 10;
  background: white;

  @media ${device.laptop}{
    grid-column: 1 / span 3;
    background: transparent;
    padding: 2rem;
    box-sizing: border-box;
    pointer-events: none;
`;

const Title = styled.h1`
  font-family: ${props => props.theme.type.heading};
  text-transform: uppercase;
  font-size: 30px;
  font-weight: 400;
  margin: 0;
  text-shadow: 0px 0px 20px rgba(239, 239, 239, 0.3);

  a {
    color: rgb(51, 51, 51);
    text-decoration: none;
  }

  @media ${device.laptop} {
    font-size: 48px;
    line-height: 48px;
  }
`;

const Images = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  height: 40vh;
  z-index: 1;
  mix-blend-mode: darken;
  display: flex;
  transform: scale(3);
  position: relative;

  .swiper-container {
    mix-blend-mode: darken;
  }

  @media ${device.laptop} {
    height: 100%;
    position: absolute;
    transform: none;
    /* display: grid; */
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 1vw;
    align-self: flex-start;
  }

  li {
    overflow: hidden;
  }

  img {
    width: 100%;
    height: 100%;
    mix-blend-mode: darken;
    transition: 0.2s all ease-in-out;
    object-fit: contain;
    object-position: center center;
  }
`;

const SKU = styled.span`
  align-self: end;
  font-family: ${props => props.theme.type.new};
  margin-bottom: 2rem;
  display: block;
  font-size: 20px;
  letter-spacing: 0.25em;
`;

const PostLink = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;

  a {
    text-indent: -999rem;
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const Price = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 1rem 0;
  font-family: ${props => props.theme.type.new};

  span {
    font-weight: 500;
    font-size: 24px;
    position: relative;
    margin: 1rem 0;
    color: ${props => (props.sale ? `rgb(228,94,97)` : `black`)};

    @media ${device.laptop} {
      font-size: 3.5vh;
    }

    &:after {
      position: absolute;
      top: calc(50% - 0.5vh);
      top: 10px;
      left: -10%;
      content: ${props => (props.sale ? `""` : `none`)};
      width: 120%;
      transform: rotate(15deg);
      transform-origin: top left;
      height: 1vh;
      background: rgb(51, 51, 51);
    }
  }

  @media ${device.laptop} {
    margin: 0;
  }

  aside {
    padding-left: 2rem;
    font-weight: 500;
    font-size: 24px;
    position: relative;

    @media ${device.laptop} {
      font-size: 3vh;
    }
  }
`;

const Input = styled.input`
  appearance: none;
  border: 2px solid black;
  padding: 1rem;
  width: 100%;
  border-radius: 0;
  height: 3vw;
  min-height: 60px;
  outline: 0;
  font-family: ${props => props.theme.type.secondary};
  font-size: 14px;
  font-weight: 500;
  position: relative;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);
  z-index: 5;
  pointer-events: all;
  box-sizing: border-box;
  background: white;

  @media ${device.laptop} {
    width: auto;
    margin: 0;
    font-size: 1.25vw;
  }

  &::placeholder {
    font-size: 16px;
    font-weight: 300;

    @media ${device.laptop} {
      font-size: 1.25vw;
    }
  }
`;

const Timer = styled.div`
  font-family: ${props => props.theme.type.new};
  font-size: 24px;
  font-weight: 100;
  z-index: 10;
  border-top: 1px solid rgba(0, 0, 0, 0.12);

  @media ${device.laptop} {
    border: 0;
  }

  form {
    display: flex;
    margin-top: 2rem;
  }

  span {
    font-size: 36px;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 1rem;
    display: block;

    strong {
      font-size: 14px;
      margin-right: 1rem;

      @media ${device.laptop} {
        font-size: 24px;
        margin-right: 4rem;
      }
    }

    sup {
      font-size: 18px;
      margin-left: 4px;

      @media ${device.laptop} {
        font-size: 24px;
      }
    }

    @media ${device.laptop} {
      font-size: 44px;
      margin: 0;
    }
  }
`;

class Product extends Component {
  state = {
    variant: "",
    variantSelected: false,
    subscribed: false
  };

  handleClick = () => {
    // Create a checkout if cart is empty
    const variantId = btoa(
      `gid://shopify/ProductVariant/${this.state.variant}`
    );

    if (this.props.cart.lineItems) {
      this.props.addToCart(this.props.cart.id, variantId).then(() => {
        this.props.openCart();
      });
    } else {
      this.props
        .createCheckout()
        .then(() => {
          this.props.addToCart(this.props.cart.id, variantId);
        })
        .then(() => {
          this.props.openCart();
        })
        .catch(err => console.log(err));
    }
  };

  handleChange = e => {
    this.setState({ variant: e.target.value });

    if (e.target.value !== "") {
      this.setState({ variantSelected: true });
    }
  };

  renderImages() {
    let count = 5;
    let images = [].concat(...Array(count).fill(this.props.images));
    let productImages = images.slice(0, 5);

    return productImages.map((image, index) => {
      const filename = image.src.replace(/^.*[\\/]/, "").split(".")[0];
      const medium = `${filename}_720x`;
      const newThumb = image.src.replace(filename, medium);
      return (
        <li key={index}>
          <Link
            to={`/shop/${this.props.type.toLowerCase()}/${this.props.handle}`}
          >
            <img alt={`${this.props.title}-${index}`} src={newThumb} />
          </Link>
        </li>
      );
    });
  }

  subscribe = e => {
    e.preventDefault();
    this.setState({ subscribed: true });
  };

  render() {
    const cleanPrice = this.props.price.split(".")[0];

    const { options, variants, title, sku, releaseDate } = this.props;

    const inventory = variants.reduce((a, b) => a + b.inventory_quantity, 0);

    // Renderer callback with condition
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
      if (completed) {
        // Render a completed state
        return inventory === 0 ? (
          <Button disabled>Sold Out</Button>
        ) : (
          <>
            {variants.length > 1 && (
              <Select
                name={
                  options.length > 1
                    ? `Select Style`
                    : `Select ${options[0].name}`
                }
                value={this.state.variant}
                variants={variants}
                onChange={this.handleChange}
              />
            )}
            <Button
              disabled={
                variants.length > 1 ? !this.state.variantSelected : false
              }
              onClick={this.handleClick}
            >
              Add to Cart
            </Button>
          </>
        );
      } else {
        // Render a countdown
        return (
          <Timer>
            <div>
              <span>
                <strong>Drops in</strong>
                {isMobile && <br />}
                {days}
                <sup>d</sup> {zeroPad(hours, 2)}
                <sup>h</sup> {zeroPad(minutes, 2)}
                <sup>m</sup> {zeroPad(seconds, 2)}
                <sup>s</sup>
              </span>
            </div>
            <form onSubmit={e => this.subscribe(e)}>
              {this.state.subscribed ? (
                <Button disabled>Subscribed</Button>
              ) : (
                <>
                  <Input placeholder="Email Address" />
                  <Button>Notify Me</Button>
                </>
              )}
            </form>
          </Timer>
        );
      }
    };

    return (
      <Wrapper {...this.props}>
        {isMobile ? (
          <MobileProductSlider centerMode={true}>
            {this.renderImages()}
          </MobileProductSlider>
        ) : (
          <Images releaseDate={releaseDate}>
            <Swiper slidesPerView={5} centerMode loop>
              {this.renderImages()}
            </Swiper>
          </Images>
        )}

        <Info releaseDate={releaseDate}>
          {releaseDate <= Date.now() ? (
            <>
              <SKU>OBJ — {sku.padStart(3, "0")}</SKU>
              <Title>
                <Link
                  to={`/shop/${this.props.type.toLowerCase()}/${
                    this.props.handle
                  }`}
                >
                  {title}
                </Link>
              </Title>
              <Price sale={variants[0].compare_at_price ? true : false}>
                {variants[0].compare_at_price ? (
                  <>
                    <aside>${variants[0].compare_at_price}</aside>
                    <span>${cleanPrice}</span>
                  </>
                ) : (
                  <span>${cleanPrice}</span>
                )}
              </Price>
            </>
          ) : (
            <>
              <SKU>OBJ — {sku.padStart(3, "0")}</SKU>
              <Title>{title}</Title>
            </>
          )}
          <Countdown
            date={Math.round(new Date(releaseDate).getTime())}
            renderer={renderer}
          />
        </Info>
      </Wrapper>
    );
  }
}

Product.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  variants: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  createCheckout: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  fetchCheckout: PropTypes.func.isRequired,
  releaseDate: PropTypes.number
};

export default connect(
  state => ({
    cart: state.cart
  }),
  { openCart, createCheckout, addToCart, fetchCheckout }
)(Product);
